import { RenderEvent } from 'core';
import React from 'react';

export class Link extends React.Component<{event:RenderEvent,label:string,href:string,styles?:string}>{
    render(): React.ReactNode {
        let styles = this.props.event.computeStyles(this.props.styles);
        let className = "RT-Link RT-Link--hover-underline " + styles.className;
        return <a href={this.props.href} style={styles.style} className={className}>{this.props.label}</a>
    }
}